import infoIcon from "../../assets/design-revamp/info-icon.svg";

const InfoIcon = ({ style, className = "" }) => {
  return (
    <span className={`info-icon-wrap ${className}`.trim()}>
      <img
        className="info-icon-img"
        src={infoIcon}
        alt="More information"
        style={{ ...style, width: "20px", height: "20px" }}
      />
    </span>
  );
};

export default InfoIcon;
